import type { HekateDisplayForm } from '@onshape/www-inertia';
import { FieldHtmlNameUtil } from '@onshape/www-inertia';
import type { Ref } from 'vue';
import UnifiedSignupScreenComponent from '../UnifiedSignupScreenComponent';
import AbstractSignupScreen from './AbstractSignupScreen';
import type { UnifiedSignupScreenName } from '../UnifiedSignupScreenName';
import ErrorUtil from '../../../../../util/ErrorUtil';
import type UnifiedSignupSessionInfo from '../session-info/UnifiedSignupSessionInfo';
import UnifiedSignupPlan from '../session-info/UnifiedSignupPlan';
import UnifiedSignupIntent from '../session-info/UnifiedSignupIntent';

export default class ChoosePlanSignupScreen extends AbstractSignupScreen {
  public readonly screenName: UnifiedSignupScreenName;

  public readonly onUpdatePage: VoidFunction;

  constructor({
    sessionInfo,
    formDefinition,
    screenName,
    onUpdatePage,
    isBackButtonHidden,
  }: {
    sessionInfo: Ref<UnifiedSignupSessionInfo>;
    formDefinition: Ref<HekateDisplayForm>;
    screenName: UnifiedSignupScreenName;
    onUpdatePage: VoidFunction;
    isBackButtonHidden: Ref<boolean>;
  }) {
    super({ sessionInfo, formDefinition, isBackButtonHidden });
    this.screenName = screenName;
    this.onUpdatePage = onUpdatePage;
  }

  public getVisibleComponents(): UnifiedSignupScreenComponent[] {
    return [];
  }

  public getValidatedComponents(): UnifiedSignupScreenComponent[] {
    return [
      new UnifiedSignupScreenComponent({
        displayField: this.getField(FieldHtmlNameUtil.chooseYourOnshapePlan),
      }),
    ];
  }

  public predicate(): boolean {
    throw ErrorUtil.internalError({ msg: 'ChoosePlanSignupScreen has no predicate' });
  }

  public async toNextScreen(): Promise<boolean> {
    const planValue = this.getField(FieldHtmlNameUtil.chooseYourOnshapePlan).val;
    if (!planValue) {
      return true;
    }
    const { persona } = this.sessionInfo.value;
    this.sessionInfo.value.isChooseOwnPlan = false;
    const plan = UnifiedSignupPlan.fromString(planValue);
    this.sessionInfo.value.chosenPlan = plan;
    if (
      !persona ||
      persona.isEduPersona() ||
      !(plan.compareTo(UnifiedSignupPlan.edu) || plan.compareTo(UnifiedSignupPlan.educator))
    ) {
      return true;
    }

    this.sessionInfo.value.intent = UnifiedSignupIntent.eduIntent;
    this.getField(FieldHtmlNameUtil.whatIsYourExperience).val = '';
    this.sessionInfo.value.persona = null;
    return true;
  }

  public getProgress(): number {
    return 60; // TODO we could make this different for each instance by passing in value to the constructor
  }
}
